/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React from "react"

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M17.188 2.188H2.813a.624.624 0 00-.626.624v14.376c0 .345.28.625.626.625h14.374c.346 0 .625-.28.625-.625V2.813a.624.624 0 00-.625-.626zm-.625 14.374h-3.596v-4.8h2.031l.305-2.358h-2.336V7.898c0-.683.19-1.148 1.168-1.148h1.248V4.64c-.217-.029-.957-.093-1.82-.093-1.801 0-3.034 1.1-3.034 3.117v1.738H8.494v2.358h2.037v4.803H3.437V3.438h13.126v13.124z"
      fill="currentColor"
    />
  </svg>
)
